<div class="py-4 container-fluid overload-memo-page">
  <h4 class="mb-4 overload-memo-title">บันทึกขออนุมัติตารางสอน</h4>

  <div class="overload-memo-layout">
    <div class="overload-memo-card">
      <div class="overload-memo-card-body">
        <form [formGroup]="form" class="overload-memo-form" (ngSubmit)="onSubmit()">
          <app-select
            label="เทอมการศึกษา"
            formControlName="academicTerm"
            [options]="academicTermNameOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>

          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>

          <app-input
            label="เลขที่เอกสาร"
            formControlName="documentNumber"
            [required]="true"
            [error]="form.controls.documentNumber.invalid && form.controls.documentNumber.touched ? form.controls.documentNumber.errors : null"
            inputClass="app-input-size-md"
            classes="mb-0"
          ></app-input>

          <app-datepicker
            label="วันที่ออกเอกสาร"
            formControlName="effectiveDate"
            [required]="true"
            [error]="form.controls.effectiveDate.invalid && form.controls.effectiveDate.touched ? form.controls.effectiveDate.errors : null"
            inputClass="app-input-size-md"
            classes="mb-0"
          ></app-datepicker>

          <div class="overload-memo-actions">
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="loading() || submitting() || !canSubmit()"
            >
              {{ submitting() ? 'กำลังดำเนินการ...' : submitLabel() }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="loading() || submitting() || !canSendRequest()"
              [title]="memo() && canSubmit() && !canSendRequest() ? 'กรุณากดสร้างเอกสารเพื่อพรีวิวก่อนส่งคำขอ' : ''"
              (click)="onSendRequest()"
            >
              ส่งคำขอ
            </button>
            @if (canDownload()) {
              <button
                type="button"
                class="btn btn-primary"
                (click)="onDownloadPdf()"
              >
                ดาวน์โหลด PDF
              </button>
            }
          </div>
        </form>

        @if (submitError(); as error) {
          <div class="alert alert-danger overload-memo-alert">
            {{ error }}
          </div>
        }

        @if (memo(); as item) {
          <div class="overload-memo-summary">
            <app-status-badge
              [tone]="statusDisplay(item.status_code).tone"
              [label]="statusDisplay(item.status_code).label"
              size="md"
            />
            <span>จำนวนอาจารย์: {{ entriesCount(item) }}</span>
          </div>

          <div class="overload-memo-certifications">
            <div class="overload-memo-section-heading">
              สถานะการรับรองจากหัวหน้างานการศึกษา
            </div>
            <div class="overload-memo-certification-row">
              <span>{{ item.education_head_name || 'หัวหน้างานการศึกษา' }}</span>
              <app-status-badge
                [tone]="certificationStatusDisplay(educationHeadCertificationStatus()).tone"
                [label]="certificationStatusDisplay(educationHeadCertificationStatus()).label"
              />
            </div>
          </div>

          <div class="overload-memo-certifications">
            <div class="overload-memo-section-heading">
              สถานะการรับรองจากรองคณบดีฝ่ายวิชาการ
            </div>
            <div class="overload-memo-certification-row">
              <span>{{ item.vice_dean_name || 'รองคณบดีฝ่ายวิชาการ' }}</span>
              <app-status-badge
                [tone]="certificationStatusDisplay(viceDeanCertificationStatus()).tone"
                [label]="certificationStatusDisplay(viceDeanCertificationStatus()).label"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <div class="overload-memo-card overload-memo-preview-card">
      <div class="overload-memo-card-body">
        <div class="overload-memo-preview-header">
          <h5>Preview</h5>
          @if (pdfLoading()) {
            <span class="text-muted">กำลังโหลด...</span>
          }
        </div>

        @if (pdfPreviewUrl(); as previewUrl) {
          <iframe
            class="overload-memo-pdf-frame"
            [src]="previewUrl"
            title="Overload memo PDF preview"
          ></iframe>
        } @else if (pdfError()) {
          <div class="overload-memo-empty">ไม่สามารถโหลด PDF ได้</div>
        } @else {
          <div class="overload-memo-empty">ยังไม่มี PDF</div>
        }
      </div>
    </div>
  </div>
</div>
